"use client";

import { $api, apiAuth } from "@/openapi/client-auth";
import {
  createUseAmazonStatisticsDaily,
  createUseAmazonStatisticsSummary,
  createUseDiscountCodes,
  createUseDiscountCodesByShop,
  createUseFavouriteShops,
  createUseLatestDiscountCodes,
  createUseMainCategoriesWithCounts,
  createUsePopularProjects,
  createUsePopularShops,
  createUseProductSearch,
  createUseProjectSearch,
  createUseProjectStatistics,
  createUseProjectSupporters,
  createUseRecentTransactions,
  createUseRelatedProjects,
  createUseShopSearch,
} from "@donista/shared/hooks/queries";
import {
  createUseFavouriteShopCount,
  createUseFavouriteShopsInfinite,
  createUseToggleFavouriteShop,
} from "@donista/shared/hooks/use-favourite-shops";
import {
  createUseWishlistCount,
  createUseWishlistProductsInfinite,
  createUseToggleWishlist,
} from "@donista/shared/hooks/use-wishlist";

export const useAmazonStatisticsDaily = createUseAmazonStatisticsDaily($api);
export const useAmazonStatisticsSummary = createUseAmazonStatisticsSummary($api);
export const useDiscountCodes = createUseDiscountCodes($api);
export const useDiscountCodesByShop = createUseDiscountCodesByShop($api);
export const useFavouriteShops = createUseFavouriteShops($api);
export const useFavouriteShopsInfinite = createUseFavouriteShopsInfinite($api);
export const useFavouriteShopCount = createUseFavouriteShopCount($api);
export const useToggleFavouriteShop = createUseToggleFavouriteShop(apiAuth);
export const useLatestDiscountCodes = createUseLatestDiscountCodes($api);
export const useMainCategoriesWithCounts = createUseMainCategoriesWithCounts($api);
export const usePopularProjects = createUsePopularProjects($api);
export const usePopularShops = createUsePopularShops($api);
export const useProductSearch = createUseProductSearch($api);
export const useProjectSearch = createUseProjectSearch($api);
export const useProjectStatistics = createUseProjectStatistics($api);
export const useProjectSupporters = createUseProjectSupporters($api);
export const useRecentTransactions = createUseRecentTransactions($api);
export const useRelatedProjects = createUseRelatedProjects($api);
export const useShopSearch = createUseShopSearch($api);
export const useWishlistCount = createUseWishlistCount($api);
export const useWishlistProductsInfinite = createUseWishlistProductsInfinite($api);
export const useToggleWishlist = createUseToggleWishlist(apiAuth);
